function renInPer(value){
  return value / 100;
}

function limitToTwoDigit(perNum, ind) {

  if (typeof window !== `undefined`) {
    return parseFloat(perNum).toFixed(ind);

  }else{
    return parseFloat(perNum)
  }
}


function _calVol(enLeadsPM, leadPercent) {
  return enLeadsPM * renInPer(leadPercent);
}


function _outOPPpm(visConverRate, enLead_MQL) {
  return visConverRate * renInPer(enLead_MQL);
}


function _outCWpm(visConverRate, enLead_MQL, enMQL_opp) {
  return visConverRate * renInPer(enLead_MQL) * renInPer(enMQL_opp);
}


function _calLtv(enACV, enAvgSubcriptionlength) {
  return enACV * enAvgSubcriptionlength;
}


function _outAvgLeadValue(LTV, enLead_MQL, enMQL_opp, enOpp_CW) {
  return LTV * (renInPer(enLead_MQL) * renInPer(enMQL_opp) * renInPer(enOpp_CW));
}

function _outAvgMQLvalue(LTV, enMQL_opp, enOpp_CW) {
  return LTV * (renInPer(enMQL_opp) * renInPer(enOpp_CW));
}


function _outAvgOppValue(LTV, enOpp_CW) {
  return LTV * renInPer(enOpp_CW);
}

function PV(rate, nper, pmt) {
  return pmt / renInPer(rate) * (1 - Math.pow(1 + rate, -nper));
}

function calculateROI(visConverRate, _loopEnCRImprovement, enMonthlyVisitors, enLeadsPM, outAvgLeadValue, _Optimization, enGrossMarginPct, enDiscountRate, enAvgSubcriptionlength, enAnnualInvestment) {
  
 // console.info(visConverRate, _loopEnCRImprovement, enMonthlyVisitors, enLeadsPM, outAvgLeadValue, _Optimization, enGrossMarginPct, enDiscountRate, enAvgSubcriptionlength, enAnnualInvestment);
  
  //console.info(visConverRate,enLeadsPM);
  var outNewCR = visConverRate * (1 + _loopEnCRImprovement);
  //  console.info(outNewCR);
  var outNewLeads = (enMonthlyVisitors * outNewCR / 100) - enLeadsPM;
  //    console.info(outNewLeads);
  var outNewLeadValueLTV = outNewLeads * outAvgLeadValue * renInPer(_Optimization);
  var outNewLeadValueGM = outNewLeadValueLTV * renInPer(enGrossMarginPct);
  var NewLeadValuePV = renInPer(PV(renInPer(enDiscountRate), enAvgSubcriptionlength, outNewLeadValueGM) / 5);
  // console.info('New CR :' + limitToTwoDigit(outNewCR, 2));
  // console.info('New Leads' + limitToTwoDigit(outNewLeads, 2));
  // console.info('New Lead Value (LTV)' + limitToTwoDigit(outNewLeadValueLTV, 2));
  // console.info('New Lead Value (GM)' + limitToTwoDigit(outNewLeadValueGM, 2));

  // console.info('New Lead Value (PV)' + limitToTwoDigit(NewLeadValuePV, 0));

  var ROI = (NewLeadValuePV - enAnnualInvestment) / enAnnualInvestment * 100;

  //console.info('roi :' + limitToTwoDigit(ROI, 2));
  return limitToTwoDigit(ROI, 2);
}

function RoiCalculator(Roi) {

  // step1 
  let _visConverRateNo = Roi.enLeadsPM / Roi.enMonthlyVisitors * 100;

  if (_visConverRateNo != "NaN" && _visConverRateNo != "Infinity") {
    Roi.visConverRate = _visConverRateNo; //do not round off
  }

  Roi['funnel'] = false;

  if(_visConverRateNo == 0 ||
     _visConverRateNo == "NaN" ||
      _visConverRateNo == "Infinity" || 
      Number(Roi.enMonthlyVisitors) < Number(Roi.enLeadsPM) ||
      Roi.enMonthlyVisitors =="" ||
      Roi.enLeadsPM == ""
     ){
    
    Roi.visConverRate = 0;
    return Roi;
  }

  Roi['funnel'] = true;

  // break for step 2;

  Roi['revenue-ltv'] = false;
  if (!(
    Roi.enLead_MQL != null && Roi.enMQL_opp != null && Roi.enOpp_CW != null &&
    Roi.enLead_MQL != '' && Roi.enMQL_opp != '' && Roi.enOpp_CW != '' )
  ) {
    return Roi;
  }

  Roi['revenue-ltv'] = true;

  Roi.outVolMQL = _calVol(Roi.enLeadsPM, Roi.enLead_MQL);
  Roi.outVolMQL_r = limitToTwoDigit(Roi.outVolMQL, 2);

  // break for step 3


  
  if (Roi.enMQL_opp == null ||  Roi.enACV == '' || Roi.enAvgSubcriptionlength == '' || Roi.enGrossMarginPct == '') {
    Roi['investment'] = false;
    return Roi;
  }

  Roi['investment'] = true;



  Roi.outVolOPP = _calVol(Roi.outVolMQL, Roi.enMQL_opp);
  Roi.outVolOPP_r = limitToTwoDigit(Roi.outVolOPP, 2);

  // break for step 4;
  Roi['result'] = false;
  if (Roi.enAnnualInvestment == null || Roi.enAnnualInvestment == '') {
    return Roi;
  }
  Roi['result'] = true;

  Roi.outVolCW = _calVol(Roi.outVolOPP, Roi.enOpp_CW);
  Roi.outVolCW_r = limitToTwoDigit(Roi.outVolCW, 2);

  // b user
  Roi.outOPPpm = _outOPPpm(Roi.visConverRate, Roi.enLead_MQL); // enLead_MQL user
  Roi.outOPPpm_r = limitToTwoDigit(Roi.outOPPpm, 2);
  // b user
  // c user
  Roi.outCWpm = _outCWpm(Roi.visConverRate, Roi.enLead_MQL, Roi.enMQL_opp);
  Roi.outCWpm_r = limitToTwoDigit(Roi.outCWpm, 2);

  // break for step 5;
  if (Roi.enACV == null || Roi.enAvgSubcriptionlength == null) {
    Roi.steps5 = false;
    return Roi;
  }
  Roi.steps5 = true
  Roi.LTV = _calLtv(Roi.enACV, Roi.enAvgSubcriptionlength);
  Roi.LTV_r = limitToTwoDigit(Roi.LTV, 2);

  Roi.outAvgLeadValue = _outAvgLeadValue(Roi.LTV, Roi.enLead_MQL, Roi.enMQL_opp, Roi.enOpp_CW);
  Roi.outAvgLeadValue_r = limitToTwoDigit(Roi.outAvgLeadValue, 0);

  Roi.outAvgMQLvalue = _outAvgMQLvalue(Roi.LTV, Roi.enMQL_opp, Roi.enOpp_CW);
  Roi.outAvgMQLvalue_r = limitToTwoDigit(Roi.outAvgMQLvalue, 0);
  Roi.outAvgOppValue = _outAvgOppValue(Roi.LTV, Roi.enOpp_CW);
  Roi.outAvgOppValue_r = limitToTwoDigit(Roi.outAvgOppValue, 0);

  Roi.onSiteRoIArr= [];
  Roi.onSiteRoIArrGraph= [];
  Roi.MQLRoIArr= [];
  Roi.MQLRoIArrGraph= [];
  Roi.oPPRoIArr= [];
  Roi.oPPRoIArrGraph= [];

  Roi.loopEnCRImprovement = .2;

  let feincrement = 20;
  var fecount = 0;
  for (var i = 9; i >= 0; i--) {
    var x = calculateROI(Roi.visConverRate, Roi.loopEnCRImprovement, Roi.enMonthlyVisitors, Roi.enLeadsPM, Roi.outAvgLeadValue, Roi.enOnsiteOptimization, Roi.enGrossMarginPct, Roi.enDiscountRate, Roi.enAvgSubcriptionlength, Roi.enAnnualInvestment);
    fecount++;
    var  onSiteRoIArrVar  = {
      "color": "hsl(337, 70%, 50%)",
      "x": (feincrement * fecount) + "%",
      "y": Number(x)
    }
    
    Roi.onSiteRoIArr.push(x);
    Roi.onSiteRoIArrGraph.push(onSiteRoIArrVar);


    var x = calculateROI(Roi.outOPPpm, Roi.loopEnCRImprovement, Roi.enMonthlyVisitors, Roi.outVolMQL, Roi.outAvgMQLvalue, Roi.enMQLOptimization, Roi.enGrossMarginPct, Roi.enDiscountRate, Roi.enAvgSubcriptionlength, Roi.enAnnualInvestment);
    

    var  MQLRoIArrVar  = {
      "color": "hsl(72, 70%, 50%",
      "x": (feincrement * fecount) + "%",
      "y": Number(x)
    }
    Roi.MQLRoIArr.push(x);
    Roi.MQLRoIArrGraph.push(MQLRoIArrVar);


    var x = calculateROI(Roi.outCWpm, Roi.loopEnCRImprovement, Roi.enMonthlyVisitors, Roi.outVolOPP, Roi.outAvgOppValue, Roi.enOppOptimization, Roi.enGrossMarginPct, Roi.enDiscountRate, Roi.enAvgSubcriptionlength, Roi.enAnnualInvestment);
    
    var  oPPRoIArrVar  = {
      "color": "hsl(11, 70%, 50%)",
      "x": (feincrement * fecount) + "%",
      "y": Number(x)
    }
    
    Roi.oPPRoIArr.push(x);
    Roi.oPPRoIArrGraph.push(oPPRoIArrVar);

    Roi.loopEnCRImprovement = Roi.loopEnCRImprovement + .20;
  }

  var feGraphObject = [
    {
      "id": "Roi (Onsite)",
      "color": "hsl(210, 70%, 50%)",
      "data": Roi.onSiteRoIArrGraph
    },
    {
      "id": "Roi (MQL)",
      "color": "hsl(104, 70%, 50%)",
      "data": Roi.MQLRoIArrGraph
    },
    {
      "id": "Roi (Opp)",
      "color": "hsl(11, 70%, 50%)",
      "data": Roi.oPPRoIArrGraph
    }
  ];

  
  Roi.graphData = feGraphObject;

  // console.info(Roi.onSiteRoIArr, Roi.MQLRoIArr, Roi.oPPRoIArr);



  function winnIngVarAB(ABvariationPerYear, ABwinningPCT) {
    return limitToTwoDigit((ABvariationPerYear * renInPer(ABwinningPCT)), 0);
  }
  function winnIngVarABlift(ABwinningVariation, lift) {
    return ABwinningVariation * lift;
  }

  function winnIngVarPRO(PROvariationPerYear, PROwinningPCT) {
    return limitToTwoDigit((PROvariationPerYear * renInPer(PROwinningPCT)), 0);;
  }

  function winnIngVarPROlift(PROwinningVariation, lift) {
    return PROwinningVariation * lift;
  }

  Roi.ABwinningVariation = winnIngVarAB(Roi.ABvariationPerYear, Roi.ABwinningPCT);
  Roi.ABtotalLift = winnIngVarABlift(Roi.ABwinningVariation, Roi.abLift);
  Roi.PROwinningVariation = winnIngVarPRO(Roi.PROvariationPerYear, Roi.PROwinningPCT);
  Roi.PROtotalLift = winnIngVarPROlift(Roi.PROwinningVariation, Roi.proLift);


  function scenerioROI(a, b, PROtotalLift) {
    var denomination = 20;
    // console.info(a,b,PROtotalLift);
    // console.info((Number(PROtotalLift)-Number(denomination)));
    return ((((Number(a) - Number(b)) / denomination) * (Number(PROtotalLift) - Number(denomination))) + Number(b));
  }

  Roi.scenerioROI_AB = limitToTwoDigit(scenerioROI(Roi.onSiteRoIArr[1], Roi.onSiteRoIArr[0], Roi.ABtotalLift), 2);
  Roi.scenerioROI_PRO_Onsite = limitToTwoDigit(scenerioROI(Roi.onSiteRoIArr[1], Roi.onSiteRoIArr[0], Roi.PROtotalLift), 2);
  Roi.scenerioROI_PRO_MQL = limitToTwoDigit(scenerioROI(Roi.MQLRoIArr[1], Roi.MQLRoIArr[0], Roi.PROtotalLift), 2);
  Roi.scenerioROI_PRO_OPP = limitToTwoDigit(scenerioROI(Roi.oPPRoIArr[1], Roi.oPPRoIArr[0], Roi.PROtotalLift), 2);

  Roi.previewlinkObject = Object.keys(Roi)
    .filter(key => Roi.allowed.includes(key)).reduce((obj, key) => {
      obj[key] = Roi[key];
      return obj;
    }, {});

  if (typeof window !== `undefined`) {
   window.sessionStorage.setItem('roiData', JSON.stringify(Roi));
  }
  return Roi;

}

export default RoiCalculator;


// WEBPACK FOOTER //
// ./src/components/RoiCalculator.js